<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import ProdutosGruposTable from './produtos-grupos-table'
import appConfig from "@/app.config";
// import {prodGruposChart1, prodGruposChart2 } from "../components/data-simulados";
import Swal from "sweetalert2";
import exportFromJSON from "export-from-json"
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Grupos de Produtos",
    meta: [{ descricao: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, ProdutosGruposTable, Loader },
  data() {
    return {

      title: 'Grupos de Produtos',
      items: [
        {
          text: 'Administrativo',
          href: '/',
        },
        {
          text: 'Grupos de Produtos',
          active: true,
        },
      ],
      errosValid: null,
      loadingList: true,
      loadingGraph: true,
      prodGruposList: null,
      // prodGrupoChart1: prodGruposChart1,
      // prodGrupoChart2: prodGruposChart2,
      pesqTextFilter: '',
      statusFilter: 'T',

    }
  },
  methods: {
    exportExcel(){
      console.log('exportExcel')
      const data = this.prodGruposList
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    atualizaDataList(){
      this.loadingList = true
      api.get(`${getBaseUrl()}api/prodgrupos`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter
        }
      }).then((res) => {
        console.log('then axios prodgrupo')
        console.log(res.data)


        if (res.data.error){
          console.log(res.data.error)
          this.$router.push(`/faltapermissao`);
        }else{
          this.prodGruposList = res.data[0]
          this.title = `(${this.prodGruposList.length}) Grupos de Produtos`
          this.loadingList = false
          this.loadingGraph = false
        }
      });
    },

    deletouReg(dataID){
      console.log('deletouReg_pai dataid:')
      console.log(dataID)
      this.prodGruposList = null
      this.loadingList = true
      api.delete(`${getBaseUrl()}api/prodgrupo`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)
        this.atualizaDataList()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações excluídas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },

    alterouReg(regSelecionado) {
      console.log('alterouReg_pai')
      console.log(regSelecionado)
      this.prodGruposList = null
      this.loadingList = true
      this.errosValid = []
      api.post(`${getBaseUrl()}api/prodgrupo`, {
        prodgrupoData: regSelecionado
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        // this.produtoData = res.data[0]
        this.loadingList = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros

      }).finally(()=>{
        this.atualizaDataList()
      })
    },

    criarNova() {
      console.log('criarNova')
      this.$refs.childTable.setCriarNova(true)

    }
  },
  mounted() {
    console.log('mounted prodgrupos-list_0')
    this.atualizaDataList()
  },
}
</script>

<template>

  <Layout>


    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-1">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="A">Ativos</option>
                      <option value="I">Inativos</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-2 d-inline-block">
                  <div class="position-relative">
                    <b-button variant="outline-primary" class="" @click="exportExcel">
                      <i class="bx bx-export font-size-16 align-middle "></i>
                    </b-button>
                  </div>
                </div>
              </div>

              <div class="col-sm-7">
                <div class="text-sm-end">
                  <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="criarNova">
                    <i class="mdi mdi-plus me-1"></i> Novo Grupo
                  </button>
                </div>
              </div>
            </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>

            <ProdutosGruposTable
                            ref="childTable"
                            :prodGruposList="prodGruposList"
                            @deletareg="deletouReg"
                            @alterareg="alterouReg"/>

            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript: void(0);">1</a>
              </li>

              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Next">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <Loader v-if="loadingGraph" style="min-height: 300px;">
    </Loader>

<!--    <div class="row" v-if="!loadingGraph">-->
<!--      <div class="col-lg-6">-->
<!--        <div class="card">-->
<!--          <div class="card-body">-->
<!--            <h4 class="card-title mb-3">Grupos Destaque Mês</h4>-->
<!--            <apexchart-->
<!--                class="apex-charts"-->
<!--                height="350"-->
<!--                type="bar"-->
<!--                dir="ltr"-->
<!--                :series="prodGrupoChart1.series"-->
<!--                :options="prodGrupoChart1.chartOptions"-->
<!--            ></apexchart>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="col-lg-6">-->
<!--        <div class="card">-->
<!--          <div class="card-body">-->
<!--            <h4 class="card-title mb-4">Destaques Semana</h4>-->
<!--            <apexchart-->
<!--                class="apex-charts"-->
<!--                height="320"-->
<!--                type="donut"-->
<!--                dir="ltr"-->
<!--                :series="prodGrupoChart2.series"-->
<!--                :options="prodGrupoChart2.chartOptions"-->
<!--            ></apexchart>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->


  </Layout>
</template>
